/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { ChangeEvent } from 'react'
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Select } from '@nexigendigital/nxui'
import { updateConfigOptions } from 'store/slices/shopSlice'
import { BaseHosting, PendingItem, Pricing } from 'models/shop'
import { useAppDispatch } from 'store/hooks'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    productID: number,
    productConfig: {
        id: number,
        name: string,
        description: string,
        input_type: string,
        values?: {
            display_order: number,
            id: number,
            name: string,
            pricing: Pricing[],
            show_order: number
        }[]
    } | undefined,
    items: PendingItem[],
    currentProduct: BaseHosting,
    setCurrentProduct: (product: BaseHosting) => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function ConfigOptions ({ productID, productConfig, items, currentProduct, setCurrentProduct }: Props) {
    const dispatch = useAppDispatch()
    const isItemAddedToCart = items.some((item: PendingItem) => item.product_id === productID)
    const configOption = currentProduct?.config_options?.find(({ config_id }) => config_id === productConfig?.id)

    return (
        <SelectWrapper>
            <Select
                value={configOption?.option_id}
                disabled={!isItemAddedToCart}
                onChange={(e: ChangeEvent<{ value: string }>) => {
                    if (Array.isArray(currentProduct.config_options)) {
                        setCurrentProduct({
                            ...currentProduct,
                            config_options: currentProduct.config_options.map((item) => {
                                if (item.config_id === productConfig?.id) {
                                    return {
                                        config_id: item.config_id,
                                        option_id: +e.target.value
                                    }
                                }

                                return {
                                    config_id: item.config_id,
                                    option_id: item.option_id
                                }
                            })
                        })
                        dispatch(updateConfigOptions({
                            product_id: productID,
                            config_id: productConfig?.id,
                            option_id: +e.target.value
                        }))
                    }
                }}
            >
                {productConfig?.values?.map(({ id, name }: { id: number, name: string }) => <option key={id} value={id}>{name}</option>)}
            </Select>
        </SelectWrapper>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const SelectWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`
